import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';

const { innerHeight: winHeight } = window;

const CallHistoryItem = () => (
    <div className="flex gap-x-3 p-3">
        <Skeleton.Avatar />

        <Skeleton.Icon className="size-5" />

        <div className="flex-1">
            <Skeleton.Title className="mb-3 w-32" />

            <Skeleton.Text className="w-16" />
        </div>

        <Skeleton.Text className="h-1.5 w-12" />
    </div>
);

const CallHistorySkeleton = () => (
    <div className="animate-fade w-full max-w-2xl ps-3 text-gray-200">
        <Skeleton.DateDivider />
        {Array.from({ length: Math.round(winHeight / 50) }).map((_, index) => (
            <CallHistoryItem key={index} />
        ))}
    </div>
);

export default CallHistorySkeleton;
